import { render, staticRenderFns } from "./drugstoreView.vue?vue&type=template&id=ffeca990&scoped=true&"
import script from "./drugstoreView.vue?vue&type=script&lang=js&"
export * from "./drugstoreView.vue?vue&type=script&lang=js&"
import style0 from "./drugstoreView.vue?vue&type=style&index=0&id=ffeca990&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffeca990",
  null
  
)

export default component.exports